import { useEffect, useRef } from 'react';
import { Center, Stack, Text } from '@mantine/core';
import type { FlashcardContent } from '@/features/flashcards/types/flashcard';
import { renderNoteToElement } from '../utils/renderNote';
import classes from './MusicNotationRenderer.module.css';

export function MusicNotationRenderer({ content }: { content: FlashcardContent }) {
  const ref = useRef<HTMLDivElement>(null);
  const clef = (content.content_metadata?.clef ?? 'treble') as 'treble' | 'bass';
  // On the answer (back) side the generator supplies a `label` (the note name)
  // so the back shows the staff + note in the middle plus the name beneath it.
  const label = content.content_metadata?.label as string | undefined;

  useEffect(() => {
    if (ref.current) renderNoteToElement(ref.current, content.content_value, clef);
  }, [content.content_value, clef]);

  return (
    <Center>
      <Stack align="center" gap="xs">
        <div ref={ref} className={classes.staff} data-prevent-flip="true" aria-label={`Note ${content.content_value}`} />
        {label && (
          <Text fw={600} size="xl" ta="center">
            {label}
          </Text>
        )}
      </Stack>
    </Center>
  );
}
